export const getFormFieldError = (
  errors: Record<string, string>,
  path: string
): string | undefined => {
  const bracketPath = path.replace(/\.(\d+)(?=\.|$)/g, '[$1]');
  return errors[path] ?? errors[bracketPath];
};
